module.exports = __webpack_public_path__ + "img/p115.bf37b694.jpg";